export default __webpack_public_path__ + "static/media/Sitelogo.6e429bb1.svg";